import { Component, Input, OnInit } from '@angular/core';
import { Poliza } from '../../Models/poliza';

@Component({
  selector: 'app-poliza',
  templateUrl: './poliza.component.html',
  styleUrls: ['./poliza.component.css']
})
export class PolizaComponent implements OnInit {
  @Input()
  item: Poliza;

  constructor() { }

  ngOnInit(): void {
  }
}
